import getValueFromArray from './get-value-from-array';
const getPropValue = (key, props, options = {}) => {
  const baseKey = key.split('.')[0];
  const nestedKey = key.split('.').filter((_, i) => i !== 0).join('.');
  const {
    prefix = '',
    suffix = ''
  } = options;
  const value = props[baseKey];
  if (typeof value !== 'boolean' && !value) return null;
  if (nestedKey) {
    const valueIsArray = Array.isArray(value);
    const nestedValue = !valueIsArray ? value[nestedKey] : '';
    if (valueIsArray) return getValueFromArray(nestedKey, value, prefix, suffix);
    return nestedValue ? `${prefix} ${nestedValue} ${suffix}`.trim() : null;
  }
  return `${prefix} ${value} ${suffix}`.trim();
};
export default getPropValue;
//# sourceMappingURL=get-prop-value.js.map